import {
    Component,
    Input,
    Output,
    EventEmitter,
    forwardRef
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
} from '@angular/forms';

@Component({
    selector: 'app-target-room',
    templateUrl: './target-room.component.pug',
    styleUrls: ['./target-room.component.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TargetRoomComponent),
        multi: true
    }]
})
export class TargetRoomComponent implements ControlValueAccessor {
    @Input() value: string = '';
    @Output() changeValue: EventEmitter<string> = new EventEmitter();

    constructor(
    ) {
    }

    onChange(value) {
        this.value = value;

        this.changeValue.emit(this.value);
        this.propagateChange(this.value);
    }

    // START: ControlValueAccessor Interface
    writeValue(value: string) {
        this.value = value;
    }

    propagateChange = (_: any) => {
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }
    // END: ControlValueAccessor Interface
}
